import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummarySection = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(4),
}));
